export const formatCurrency = (
  value: number | string | null | undefined,
): string => {
  const amount = Number(value ?? 0);

  return Number.isFinite(amount) ? amount.toFixed(2) : "0.00";
};
